export default __webpack_public_path__ + "static/media/vendor-accounts-inactive-img.b509e95f.svg";